import { render } from "./WelcomeFooter.vue?vue&type=template&id=3eb56211&scoped=true"
import script from "./WelcomeFooter.vue?vue&type=script&lang=js"
export * from "./WelcomeFooter.vue?vue&type=script&lang=js"

import "./WelcomeFooter.vue?vue&type=style&index=0&id=3eb56211&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb56211"]])

export default __exports__